import { meetingLocation, meetingTitle } from "ApiMaxLength";
import { HookFormDatePicker } from "components/HookForm/HookFormDatePicker";
import { HookFormDateTimePicker } from "components/HookForm/HookFormDateTimePicker";
import { HookFormInput } from "components/HookForm/HookFormInput";
import { HookFormRichText } from "components/HookForm/HookFormRichText";
import { HookFormSelect } from "components/HookForm/HookFormSelect";
import { HookFormToggle } from "components/HookForm/HookFormToggle";
import { InlineSpinner } from "components/InlineSpinner";
import { ResourceKeys, useEditMeeting, useMeetingStatuses, useTranslations } from "providers";
import React from "react";

export const EditMeetingForm: React.FC = () => {
  const i18n = useTranslations();
  const { meetingStatuses } = useMeetingStatuses();
  const { form, isLoading } = useEditMeeting();
  const { control } = form;

  if (!control) {
    return null;
  }

  if (isLoading) {
    return <InlineSpinner text={i18n.Meeting_Loading_EditForm} />;
  }

  return (
    <>
      <HookFormInput
        name="title"
        label={ResourceKeys.Meeting_Title_Title}
        control={control}
        required
        maxLength={meetingTitle}
        contextHelp={ResourceKeys.Meeting_Title_Description}
      />

      <HookFormDateTimePicker
        name="eventDate"
        label={ResourceKeys.Meeting_EventDate_Title}
        control={control}
        required
        timeLabel={ResourceKeys.Meeting_EventTime_Title}
        contextHelp={ResourceKeys.Meeting_EventDate_Description}
      />

      <HookFormDateTimePicker
        name="endDate"
        label={ResourceKeys.Meeting_EndDate_Title}
        control={control}
        required
        timeLabel={ResourceKeys.Meeting_PlannedEndTime_Title}
        contextHelp={ResourceKeys.Meeting_EndDate_Description}
      />

      <HookFormDatePicker
        name="submissionDate"
        label={ResourceKeys.Meeting_SubmissionDate_Title}
        control={control}
        contextHelp={ResourceKeys.Meeting_SubmissionDate_Description}
      />

      <HookFormInput
        name="location"
        label={ResourceKeys.Meeting_Location_Title}
        control={control}
        maxLength={meetingLocation}
        contextHelp={ResourceKeys.Meeting_Location_Description}
      />

      <HookFormRichText
        name="note"
        label={ResourceKeys.Meeting_Note_Title}
        control={control}
        contextHelp={ResourceKeys.Meeting_Note_Description}
      />

      <HookFormSelect
        name="status"
        label={ResourceKeys.Meeting_Status_Title}
        control={control}
        required
        options={meetingStatuses}
        contextHelp={ResourceKeys.Meeting_Status_Description}
      />

      <HookFormToggle
        name="locked"
        label={ResourceKeys.Meeting_Locked_Title}
        control={control}
        contextHelp={ResourceKeys.Meeting_Locked_Description}
      />

      <HookFormToggle
        name="isTemplate"
        label={ResourceKeys.Meeting_IsTemplate_Title}
        control={control}
        contextHelp={ResourceKeys.Meeting_IsTemplate_Description}
      />
    </>
  );
};
